import { render, staticRenderFns } from "./JobNotesList.vue?vue&type=template&id=c4728af0&scoped=true&"
import script from "./JobNotesList.vue?vue&type=script&lang=js&"
export * from "./JobNotesList.vue?vue&type=script&lang=js&"
import style0 from "./JobNotesList.vue?vue&type=style&index=0&id=c4728af0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4728af0",
  null
  
)

export default component.exports